import moment from 'moment-timezone';
import * as React from 'react';
import styled from 'styled-components';

const TimezoneContainer = styled.div.attrs<{}>({
	className: 'tws-timezone-container',
})``;
TimezoneContainer.displayName = 'TimezoneContainer';

export class Timezone extends React.Component<{}> {
	public render() {
		const userZoneName = moment.tz.guess();

		return <TimezoneContainer>{`${moment.tz(userZoneName).format('z')} (GMT ${moment.tz(userZoneName).format('Z')})`}</TimezoneContainer>;
	}
}
